import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

export default function CategoryFilter({ categories, selectedCategory, onChange }) {
  const { theme } = useTheme();

  return (
    <div>
      <label className={`block text-sm font-medium mb-2 ${theme.text}`}>
        Category
      </label>
      <select
        value={selectedCategory || ''}
        onChange={(e) => onChange(e.target.value || null)}
        className={`w-full px-3 py-2 rounded-lg border ${theme.border} ${theme.card} ${theme.text} focus:outline-none focus:ring-2 focus:ring-blue-500`}
      >
        <option value="">All Categories</option>
        {categories.map((category) => (
          <option key={category.id} value={category.id}>
            {category.categoryName} ({category.listingCount || 0})
          </option>
        ))}
      </select>
    </div>
  );
}
